export default "__VITE_ASSET__DadB$CfU__"